// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2WaA2","filesListContainer":"PosDisputesFiles_filesListContainer__1h3E1","filesButton":"PosDisputesFiles_filesButton__1y7zw"};